import type { ReviewStatus } from "@models/reviews";

// One colour per canonical state, shared by the list, the legend and the detail header.
export const STATUS_COLOR: Record<ReviewStatus, string> = {
  empty: "gray",
  outstanding: "blue",
  pending: "yellow",
  imported: "teal",
};

export const STATUS_ORDER: ReviewStatus[] = ["empty", "outstanding", "pending", "imported"];
